import { IApartmentDetail } from '../../../modules/apartments/store';

export const editApartmentValues = (paidServicesValue: boolean, apartmentValue: IApartmentDetail) => ({
  floor: apartmentValue.floor?.name,
  name: apartmentValue.name,
  number: apartmentValue.number,
  paidServicesActive: paidServicesValue,
});
